import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SessionsListState } from './sessions-list.reducer';

export const selectSessionsListState = createFeatureSelector<SessionsListState>('sessionsList');

export const selectSessions = createSelector(selectSessionsListState, (s) => s.sessions);
export const selectSessionsLoading = createSelector(selectSessionsListState, (s) => s.isLoading);
export const selectSessionsError = createSelector(selectSessionsListState, (s) => s.error);
export const selectSessionsPage = createSelector(selectSessionsListState, (s) => s.page);
export const selectSessionsTotal = createSelector(selectSessionsListState, (s) => s.total);
export const selectSessionsPerPage = createSelector(selectSessionsListState, (s) => s.perPage);
